import React from 'react';

import './styles.scss';

import useFormCtx from "../../utils/useFormCtx";
import LabelDisplay from "../LabelDisplay";

import MultipleDocumentUpload from "./components/MultipleDocumentUpload";
import SingleDocumentUpload from "./components/SingleDocumentUpload";

export default (props) => {
  const [loading, setLoadingState] = React.useState();

  const {
    id,
    label,
    name,
    value = [],
    disabled,
    isRequired,
    error,
    showError,
    helperText,
    onChange,
    multiple,
    uploadName,
    apiUpload,
    apiRemove,
    uploadUrl,
  } = useFormCtx(props);

  const uploadData = (callback) => (e) => {
    setLoadingState(true);

    const filesArr = Array.prototype.slice.call(e.target.files)
    const filesUploadList = filesArr.map((file) => {
      const uploadFN = apiUpload({uploadUrl, docType: uploadName, data: file});
      return uploadFN.promise.then((res) => ({id: res.id, name: file.name}))
    });

    Promise.all(filesUploadList)
        .then(callback)
        .finally(() => setLoadingState(false));
  }

  const uploadFile = uploadData((res) => {
    onChange(name, [...value, ...res]);
  });
  const reUploadFile = (i) => uploadData((res) => {
    const newFile = res[0];
    const nextValues = [...value];

    nextValues[i] = {id: newFile.id, name: newFile.name};

    onChange(name, nextValues);
  });
  const deleteFile = (id) => (e) => {
    e.stopPropagation();


    setLoadingState(true);
    apiRemove({id}).then(() => {
      const nextValues = [...value].filter((el) => el.id !== id);
      onChange(name, nextValues);
      setLoadingState(false);
    })
  }

  const clickOnUpload = (id) => () => document.getElementById(id).click();

  const btnProps = {
    clickOnUpload,

    uploadFile,
    reUploadFile,
    deleteFile,

    id,
    value,
    loading,
    disabled
  }

  return (
    <div className="merchant-field merchant-upload">
      <LabelDisplay
        id={id}
        label={label}
        isRequired={isRequired}
      />
      {multiple
        ? (
          <MultipleDocumentUpload {...btnProps} />
        ) : (
          <SingleDocumentUpload {...btnProps} />
        )
      }
    </div>
  )
}
